import { CoverPhoto } from './CoverPhoto'
import { CoverPhotoOverlay } from './CoverPhotoOverlay'

export { CoverPhoto, CoverPhotoOverlay }
